import { render, staticRenderFns } from "./ProjectUploadCreate.vue?vue&type=template&id=72bb7dac"
import script from "./ProjectUploadCreate.vue?vue&type=script&lang=js"
export * from "./ProjectUploadCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports